// Cookie plugin
jQuery.cookie = function(b, j, m) {
  if (typeof j !== "undefined") {
    m = m || {};
    if (j === null) {
      j = "";
      m.expires = -1;
    }
    var e = "";
    if (m.expires && (typeof m.expires === "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires === "number") {
        f = new Date();
        f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000));
      } else {
        f = m.expires;
      }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + (m.path) : "";
    var g = m.domain ? "; domain=" + (m.domain) : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie !== "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) === (b + "=")) {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

// Module to show Recently Viewed Products
Shopify.Products = (function() {
  var config = { 
    howManyToShow: 1, // Show one product at a time
    howManyToStoreInMemory: 10, 
    wrapperId: 'recently-viewed-products', 
    templateId: 'recently-viewed-product-template',
    onComplete: null
  };

  var productHandleQueue = [];
  var wrapper = null;
  var template = null;

  var cookie = {
    configuration: {
      expires: 90,
      path: '/',
      domain: window.location.hostname
    },
    name: 'shopify_recently_viewed',
    write: function(recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(' '), this.configuration);
    },
    read: function() {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(' ');
      }
      return recentlyViewed;        
    },
    destroy: function() {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }       
    }
  };

  var showLoader = function() {
    jQuery('#loader').show(); // Show a loader
  };

  var hideLoader = function() {
    jQuery('#loader').hide(); // Hide the loader
  };

  var finalize = function() {
    wrapper.show();
    hideLoader();
    if (config.onComplete) {
      try { config.onComplete(); } catch (error) { }
    }  
  };

 var moveAlong = function() {
    if (productHandleQueue.length) {
        var isArabic = window.location.pathname.includes('/ar');
        var basePath = isArabic ? '/ar/products/' : '/products/';

        jQuery.ajax({
            dataType: 'json',
            url: basePath + productHandleQueue[0] + '.js',
            cache: false,
            success: function(product) {       
                template.tmpl(product).appendTo(wrapper);
                productHandleQueue.shift();
                moveAlong(); // Process next product if any
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error('Failed to load product:', textStatus, errorThrown);
                cookie.remove(productHandleQueue[0]);
                productHandleQueue.shift();
                moveAlong(); // Process next product if any
            }
        });
    } else {
        finalize();
    }
};


  return {
    resizeImage: function(src, size) {
      if (size == null) {
        return src;
      }

      if (size == 'master') {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      } else {
        return null;
      }
    },

    showRecentlyViewed: function(params) {
      var params = params || {};

      jQuery.extend(config, params);

      productHandleQueue = cookie.read();
      
      template = jQuery('#' + config.templateId);
      wrapper = jQuery('#' + config.wrapperId);

      if (template.length && wrapper.length) {
        showLoader();
        moveAlong();    
      }
    },
    getConfig: function() {
      return config;
    },

    clearList: function() {
      cookie.destroy();      
    },
    recordRecentlyViewed: function(params) {
      var params = params || {};
      jQuery.extend(config, params);
      var recentlyViewed = cookie.read();
      if (window.location.pathname.indexOf('/products/') !== -1) {
        var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
        var position = jQuery.inArray(productHandle, recentlyViewed);
        if (position === -1) {
          recentlyViewed.unshift(productHandle);
          recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);              
        }
        cookie.write(recentlyViewed);
      }
    }
  };
})();

// Money format handler
Shopify.money_format = "KWD {{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }
  var placeholder = formatString.match(placeholderRegex)[1];
  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2); // Default case
      break;
  }
  return formatString.replace(placeholderRegex, value);
};
